import { render, staticRenderFns } from "./TodoListItem.vue?vue&type=template&id=865659dc&scoped=true"
import script from "./TodoListItem.vue?vue&type=script&lang=js"
export * from "./TodoListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865659dc",
  null
  
)

export default component.exports